// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 3.568a.568.568 0 01-.568.567H4.865a.73.73 0 00-.73.73v15.567a.568.568 0 11-1.135 0V4.865A1.865 1.865 0 014.865 3h15.567c.314 0 .568.254.568.568z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;